import { domain } from 'modules/data';

import { messages } from './RuleTypeSection.messages';
import { ScheduleOptionReference } from './RuleTypeSection.types';

export const options: ScheduleOptionReference[] = [
    {
        id: domain.ScheduleOption.EveryDay,
        name: messages.periodEveryDay,
    },
    {
        id: domain.ScheduleOption.EveryWorkingDay,
        name: messages.periodEveryWorkingDay,
    },
    {
        id: domain.ScheduleOption.EveryWeekMonday,
        name: messages.periodEveryWeekMonday,
    },
    {
        id: domain.ScheduleOption.EveryMonthMondayOf4thWeek,
        name: messages.periodEveryMonthMondayOf4thWeek,
    },
    {
        id: domain.ScheduleOption.EveryMonthLastMonday,
        name: messages.periodEveryMonthLastMonday,
    },
    {
        id: domain.ScheduleOption.EveryYearDecember25th,
        name: messages.periodEveryYearDecember25th,
    },
    {
        id: domain.ScheduleOption.Custom,
        name: messages.periodCustom,
    },
];
